export default __webpack_public_path__ + "static/media/DeepDAOPrivacyPolicy.7e81b66b.pdf";